export const ENSAIOS_CARACTERIZACAO = [
  {
    id: "caracterizacao-granulometria",
    nome: "Granulometria",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-densidade-absorcao",
    nome: "Densidade e absorção",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-massa-unitaria",
    nome: "Massa unitária",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-torroes-argila",
    nome: "Torrões de argila",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-materiais-pulverulentos",
    nome: "Materiais pulverulentos",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-impurezas-organicas",
    nome: "Impurezas orgânicas",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-equivalente-areia",
    nome: "Equivalente de areia",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-particulas-leves",
    nome: "Partículas leves",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-sais-cloretos-sulfatos",
    nome: "Sais, cloretos e sulfatos",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-abrasao-los-angeles",
    nome: "Abrasão Los Angeles",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
  {
    id: "caracterizacao-indice-forma",
    nome: "Índice de forma",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Caracterização",
  },
];

export const ENSAIOS_COMPACTACAO = [
  {
    id: "compactacao-simples",
    nome: "Compactação simples",
    rota: "/app/ensaio-compactacao",
    categoria: "Compactação",
  },
  {
    id: "compactacao-completo",
    nome: "Compactação completa",
    rota: "/app/ensaio-compactacao",
    categoria: "Compactação",
  },
];

export const ENSAIOS_LABORATORIO = [
  {
    id: "raa",
    nome: "Ensaio RAA",
    rota: "/app/ensaio-raa",
    categoria: "Concreto",
  },
  {
    id: "cimentoConsistenciaPega",
    nome: "Consist. Cimento/Pega",
    rota: "/app/cimento-consistencia-pega",
    categoria: "Concreto",
  },
  {
    id: "caracterizacaoAgregados",
    nome: "Cadastrar Caracterização",
    rota: "/app/cadastro-caracterizacao",
    categoria: "Concreto",
    subEnsaios: ENSAIOS_CARACTERIZACAO,
  },
  {
    id: "compactacao",
    nome: "Ensaio de Compactação",
    rota: "/app/ensaio-compactacao",
    categoria: "Solos",
    subEnsaios: ENSAIOS_COMPACTACAO,
  },
  {
    id: "solo-cimento",
    nome: "Ensaio de Tijolo Solo-Cimento",
    rota: "/app/ensaio-solo-cimento",
    categoria: "Solos",
  },
  {
    id: "granulometria-asfalto",
    nome: "Caracterização de Agregado para Asfalto",
    rota: "/app/caracterizacao-asfalto",
    categoria: "Asfalto",
  },
];

export const STATUS_ENSAIO_SOLICITADO = {
  pendente: "Pendente",
  em_andamento: "Em andamento",
  concluido: "Concluído",
  cancelado: "Cancelado",
};

export function formatarDataBR(data) {
  if (!data) return "-";
  if (typeof data === "string" && data.includes("-")) {
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }
  if (data?.toDate) return data.toDate().toLocaleDateString("pt-BR");
  return String(data);
}

export function labelMaterial(material = {}) {
  return [
    material.codigo || material.Codigo,
    material.descricao || material.Descricao || material.nome || material.Nome,
    material.Fornecedor && `Fornecedor: ${material.Fornecedor}`,
    material.LocalColeta && `Local: ${material.LocalColeta}`,
  ].filter(Boolean).join(" - ");
}

export function normalizarTexto(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}
